var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.982 6.66H9.84V1.519C9.84.91 9.304.375 8.696.375H7.554A1.15 1.15 0 006.41 1.518V6.66H1.268A1.15 1.15 0 00.125 7.804v1.142c0 .643.5 1.143 1.143 1.143H6.41v5.143c0 .643.5 1.143 1.143 1.143h1.142c.608 0 1.143-.5 1.143-1.143V10.09h5.143c.607 0 1.143-.5 1.143-1.143V7.804c0-.608-.536-1.143-1.143-1.143z",
    fill: "#000"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/Home/components/FAQ/assets/svg/plus-black.svg";
export { SvgPlusBlack as ReactComponent };